const accordion = ($el) => {
    const elements = [$el]

    elements.forEach((element) => {
        $(element).click(function () {
            if ($(this).parent().attr('aria-expanded') == 'true') $(this).parent().attr('aria-expanded', 'false')
            else {
                $(this).parent().attr('aria-expanded', 'true')
                if ($(this).parent().find('.slick-slider')) {
                    if($(this).parent().find('.slick-slider')[0]) $(this).parent().find('.slick-slider')[0].slick.refresh()
                    if($(this).parent().find('.slick-slider')[1]) $(this).parent().find('.slick-slider')[1].slick.refresh()
                    if($(this).parent().find('.slick-slider')[2]) $(this).parent().find('.slick-slider')[2].slick.refresh()
                    if($(this).parent().find('.slick-slider')[3]) $(this).parent().find('.slick-slider')[3].slick.refresh()
                    if($(this).parent().find('.slick-slider')[4]) $(this).parent().find('.slick-slider')[4].slick.refresh()
                    if($(this).parent().find('.slick-slider')[5]) $(this).parent().find('.slick-slider')[5].slick.refresh()
                    if($(this).parent().find('.slick-slider')[6]) $(this).parent().find('.slick-slider')[6].slick.refresh()
                }
            }
        })
    })
}

export default accordion
